import { render, staticRenderFns } from "./SubmissionCard.vue?vue&type=template&id=5385cd3b&"
import script from "./SubmissionCard.vue?vue&type=script&lang=js&"
export * from "./SubmissionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports